import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchZones() {
  let result = await fetchData(`/zones/`);

  store.dispatch({
    type: "zones/update",
    payload: result ? result : [],
  });
  return result;
}

export async function fetchZonesByEstablishment(establishmentId) {
  let result = await fetchData(`/zones/establishment/${establishmentId}`);
  return result || [];
}
